import script from "./MemberForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberForm.vue?vue&type=script&setup=true&lang=ts"

import "./MemberForm.vue?vue&type=style&index=0&id=0bddbf62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bddbf62"]])

export default __exports__